module.exports = __webpack_public_path__ + "static/media/img-grow-quote.40e3947b.png";